import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Header, Icon, List, Checkbox, Pagination, Dimmer, Loader, Popup } from 'semantic-ui-react'
import currency from 'currency.js'

import { useUIState, useUIDispatch } from '../../context/store'

// const queryString = (obj) => (Object.entries(obj).map(i => [i[0], encodeURIComponent(i[1])].join('=')).join('&'));

function Listing() {
    const {loader, orders, query, totalPages: StoreTotalPages} = useUIState();
    const dispatch = useUIDispatch();
    const [totalPages, setTotalPages] = useState(0);
    const [showFirst, setShowFirst] = useState(query.page -1 >= 0);
    const [showLast, setShowLast] = useState(query.page === StoreTotalPages);

    const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const handlePageChange = (e, {activePage}) => {
        console.log(query);
        const newQuery = {
            ...query,
            page: activePage,
        }

        dispatch({
            type: 'SET_QUERY',
            payload: newQuery
        })
    }

    useEffect(() => {
        const { wp_rest } = window.theme_vars;
        const endpoint = `${wp_rest}social/v1/orders`;
        dispatch({type:'TOGGLE_LOADER'});
        axios.get(endpoint, {
            params: query
        }).then(res => {
            // setTotalPages(res.data.total_pages);
            dispatch({
                type: 'STORE_ORDERS',
                payload: res.data
            });
            dispatch({type:'TOGGLE_LOADER'});
        }).catch( err => {
            console.log(err.response);
        })
    }, [dispatch, query])

    useEffect(() => {
        setTotalPages(StoreTotalPages);
        setShowFirst(query.page -1 <= 0);
        console.log(StoreTotalPages);
        setShowLast(query.page === StoreTotalPages);
    }, [StoreTotalPages, query.page])

    return (
        <div style={{paddingBottom:100}}>
        <div style={{position:'relative',marginBottom:15}}>
        {loader &&
            <Dimmer active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        }
        <Table celled>
            <Table.Header fullWidth>
            <Table.Row>
                <Table.HeaderCell collapsing>
                    <Checkbox />
                </Table.HeaderCell>
                <Table.HeaderCell width={6}>Customer</Table.HeaderCell>
                <Table.HeaderCell width={4}>Details</Table.HeaderCell>
                <Table.HeaderCell>Platform</Table.HeaderCell>
                <Table.HeaderCell width={3}>Location</Table.HeaderCell>
                <Table.HeaderCell width={2}>Status</Table.HeaderCell>
            </Table.Row>
            </Table.Header>

            <Table.Body>
                {orders ? orders.map((order, i) => {
                    // console.log(order)
                        const totalCost = order.items.reduce((prev,curr)=>{
                            return currency(prev).add(curr.price).value;
                        }, 0);

                        const ProductList = () => {
                            return order.items.map((x, i) => <div className="item" style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between'}} key={i}>
                            <div style={{flex:1,marginRight:30}}>{x.item}</div>
                            <div>
                                <strong><small style={{display:'block',fontSize:8}}>GHS </small>{currency(x.price, {
                                        separator: ',',
                                        symbol: ''
                                    }).format()}</strong>
                            </div>
                        </div>)
                        }
                        
                        return <Table.Row key={`row-${i}`}>
                            <Table.Cell>
                                <Checkbox />
                            </Table.Cell>
                            <Table.Cell>
                                <Header as='h4'>
                                    <Header.Content>
                                    {order.customer}
                                    <Header.Subheader>{order.contact}</Header.Subheader>
                                    </Header.Content>
                                </Header>
                            </Table.Cell>
                            <Table.Cell>
                                <List divided horizontal>
                                    <Popup content={<div className="ui divided middle aligned list"><ProductList /></div>} trigger={
                                        <List.Item>
                                            {order.items.length} Items
                                        </List.Item>
                                    } />
                                    
                                    <List.Item><strong>{currency(totalCost, {
                                        separator: ',',
                                        symbol: 'GHS '
                                    }).format()}</strong></List.Item>
                                </List>
                            </Table.Cell>
                            <Table.Cell>{order.platform.name}</Table.Cell>
                            <Table.Cell>{order.location.name}</Table.Cell>
                            <Table.Cell warning>
                                <div style={{width:120}}><Icon name="attention" /> {capitalize(order.status)}</div>
                            </Table.Cell>
                        </Table.Row>
                    }
                ) : (
                    <Table.Row>
                        <Table.Cell colSpan="3">No records found!</Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
        </div>

        <Pagination
            pointing
            secondary
            boundaryRange={1}
            activePage={query.page}
            ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
            firstItem={{ content: <Icon name='angle double left' disabled={showFirst} />, icon: true }}
            lastItem={{ content: <Icon name='angle double right' disabled={showLast} />, icon: true }}
            prevItem={{ content: <Icon name='angle left' disabled={showFirst} />, icon: true }}
            nextItem={{ content: <Icon name='angle right' disabled={showLast} />, icon: true }}
            totalPages={totalPages}
            onPageChange={handlePageChange}
        />
        </div>
    )
}

export default Listing
